import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/groupService";
const store = {};
const mutations = {
    GET_GROUP_LIST_SIMPLE(state, posts) {
        state.groupListSimple = posts;
        state.groupListSimpleIsLoading = false;
    },
    GET_GROUP_DETAIL(state, posts) {
        state.groupDetail = posts.data;
        state.fieldAccess = posts.fieldAccess;
        state.fieldAccessIsLoading = false;
        state.groupDetailIsLoading = false;
    },
    GET_START_PAGES(state, posts) {
        posts.forEach(m => m.Name = `${m.Title} (${m.Url})`);
        state.startPageList = posts;
        state.startPageListIsLoading = false;
    },
    GET_MANAGEDGROUPS_BYGROUPS_LIST(state, posts) {
        state.managedGroupsByGroupList = posts;
        state.managedGroupsByGroupListIsLoading = false;
        state.managedGroupsByGroupListChanged = false;
    },
    SAVE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.groupDetailChanged = false;
            state.fieldAccessChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SAVE_MANAGEDGROUPSBYGROUP_LIST(state, posts) {
        if (posts.success == true) {
            state.managedGroupsByGroupListIsLoading = false;
            state.managedGroupsByGroupListChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
};
const state = {
    startPageListIsLoading: false,
    startPageList: [],
    managedGroupsByGroupListIsLoading: false,
    managedGroupsByGroupListChanged: false,
    managedGroupsByGroupList: [],
    groupListSimpleIsLoading: false,
    groupListSimple: [],
    groupDetailIsLoading: false,
    groupDetailChanged: false,
    groupDetail: {},
    fieldAccess: [],
    fieldAccessIsLoading: false,
    fieldAccessChanged: false,
};
const getters = {};
const actions = {
    getGroupListSimple({ commit }) {
        state.groupListSimpleIsLoading = true;
        return axios
            .get(baseUri + '/GetListSimple')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_GROUP_LIST_SIMPLE', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    getGroupDetail({ commit }, data) {
        state.groupDetailIsLoading = true;
        state.fieldAccessIsLoading = true;
        axios
            .get(baseUri + '/GetDetail?GrpId=' + data.grpId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_GROUP_DETAIL', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getStartPages({ commit }) {
        state.startPageListIsLoading = true;
        axios
            .get(baseUri + '/GetStartPages')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_START_PAGES', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getManagedGroupsByGroupId({ commit }, data) {
        state.startPageListIsLoading = true;
        axios
            .get(baseUri + '/GetManagedGroupsByGroupId?GrpId=' + data.grpId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_MANAGEDGROUPS_BYGROUPS_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    saveGroupDetail({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.groupDetail));
        formData.append("fieldAccess", JSON.stringify(state.fieldAccess));
        axios
            .post(baseUri + '/SaveDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating your record: " + res.data.errorMessage);
                }
            });
    },
    saveManagedGroupsByGroupList({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.managedGroupsByGroupList));
        axios
            .post(baseUri + '/SaveManagedGroupsByGroupList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_MANAGEDGROUPSBYGROUP_LIST', res.data);
                } else {
                    alert("An error occured while updating your record: " + res.data.errorMessage);
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}